// login statuses
export const LoginStatus_Success = 'success';
export const LoginStatus_Failed = 'failed';
//# sourceMappingURL=types.js.map